import React from 'react';
import PropTypes from 'prop-types';
import GroupedFlightStandard from '../GroupedFlightStandard';

const PastOrderCard = ({
  canExchange,
  journeyElement,
  tripCount,
  supplierInfo,
  airlineReservationId,
}) => {
  const pastTrip = journeyElement?.trips?.[tripCount] || {};
  const segments = pastTrip.segments || [];
  const { channel, account } = supplierInfo;

  const groupData = {
    destinationTerminal: pastTrip.destinationTerminal,
    arrivalTime: pastTrip.endsAtInUserTz,
    destinationCode: pastTrip?.destinationCode,
    tripDurationInMinutes: pastTrip.durationInMinutes,
    id: pastTrip.id,
    stopovers: pastTrip.stopovers,
    segments: pastTrip.segments,
    originTerminal: pastTrip.originTerminal,
    departureTime: pastTrip.startsAtInUserTz,
    originCode: pastTrip?.originCode,
    cabinClasses: pastTrip.cabinClass,
    bookingClasses: pastTrip.bookingClasses,
    fareRulePresent: null,
    resultId: null,
    airlineCodes: segments.map(({ code }) => code),
    payLater: false,
    instantTicket: journeyElement?.instantTicket,
    labels: null,
    multiTicket: null,
    approvalRequired: null,
    policiesReasons: null,
    fareTypes: pastTrip.fareType,
    punctuality: pastTrip.punctuality,
    overnight: pastTrip.overnight,
    availableSeatCount: pastTrip.availableSeatCount,
    channelTitle: [`${I18n.t(channel, { scope: 'channels' })}: ${account}`],
    marketingAirlineLogos: segments.map(({ marketingAirlineInfo }) => marketingAirlineInfo?.code),
    airlineReservationId,
  };

  const marketingAirlineQCodes = segments.map(
    ({ marketingFlightNumber, marketingCarrierCode }) => ({
      code: `${marketingCarrierCode}${marketingFlightNumber}`,
      logo: marketingCarrierCode,
    }),
  );

  return (
    <GroupedFlightStandard
      group={groupData}
      marketingAirlineQCodes={marketingAirlineQCodes}
      canExchange={canExchange}
      pastFareBrand={pastTrip.segments[0]?.fareBrand}
      isItemSelected={true}
      laymanMode={false}
      lowestFareBrandTitle={null}
      totalFilteredFareBrands={null}
      price={{}}
      filteredFareBrands={[]}
      setSidePanelBody={() => {}}
      setSidePanelTitle={() => {}}
      setOpenSidePanel={() => {}}
    />
  );
};

PastOrderCard.defaultProps = {
  journeyElement: {},
};

PastOrderCard.propTypes = {
  canExchange: PropTypes.bool.isRequired,
  journeyElement: PropTypes.shape({
    destinationCode: PropTypes.string,
    originCode: PropTypes.string,
    instantTicket: PropTypes.bool,
    trips: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        destinationTerminal: PropTypes.string,
        startsAtInUserTz: PropTypes.string,
        durationInMinutes: PropTypes.number,
        stopovers: PropTypes.arrayOf(PropTypes.shape({})),
        segments: PropTypes.arrayOf(
          PropTypes.shape({
            marketingAirlineInfo: PropTypes.shape({
              code: PropTypes.string,
            }),
            marketingFlightNumber: PropTypes.string,
            marketingCarrierCode: PropTypes.string,
          }),
        ),
        originTerminal: PropTypes.string,
        endsAtInUserTz: PropTypes.string,
        cabinClass: PropTypes.string,
        bookingClasses: PropTypes.string,
        fareType: PropTypes.string,
        punctuality: PropTypes.number,
        overnight: PropTypes.bool,
        availableSeatCount: PropTypes.number,
        airlines: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string })),
      }),
    ),
  }),
  tripCount: PropTypes.number.isRequired,
  supplierInfo: PropTypes.shape({
    channel: PropTypes.string,
    account: PropTypes.string,
  }).isRequired,
  airlineReservationId: PropTypes.string.isRequired,
};

export default PastOrderCard;
